export const TEXT_VARIANTS = {
    "hero-lg-700": { fontSize: "4.0rem", lineHeight: "1.4", fontWeight: "700" },
    "hero-lg-500": { fontSize: "4.0rem", lineHeight: "1.4", fontWeight: "500" },
    "hero-md-700": { fontSize: "3.2rem", lineHeight: "1.4", fontWeight: "700" },
    "hero-md-500": { fontSize: "3.2rem", lineHeight: "1.4", fontWeight: "500" },

    "title-lg-500": { fontSize: "2.4rem", lineHeight: "1.4", fontWeight: "500" },
    "title-lg-400": { fontSize: "2.4rem", lineHeight: "1.4", fontWeight: "400" },
    "title-md-500": { fontSize: "2.0rem", lineHeight: "1.4", fontWeight: "500" },
    "title-md-400": { fontSize: "2.0rem", lineHeight: "1.4", fontWeight: "400" },
    "title-sm-500": { fontSize: "1.6rem", lineHeight: "1.4", fontWeight: "500" },
    "title-sm-400": { fontSize: "1.6rem", lineHeight: "1.4", fontWeight: "400" },

    "body-lg-500": { fontSize: "1.6rem", lineHeight: "1.4", fontWeight: "500" },
    "body-lg-400": { fontSize: "1.6rem", lineHeight: "1.4", fontWeight: "400" },
    "body-md-500": { fontSize: "1.4rem", lineHeight: "1.4", fontWeight: "500" },
    "body-md-400": { fontSize: "1.4rem", lineHeight: "1.4", fontWeight: "400" },
    "body-sm-500": { fontSize: "1.2rem", lineHeight: "1.4", fontWeight: "500" },
    "body-sm-400": { fontSize: "1.2rem", lineHeight: "1.4", fontWeight: "400" },

    "btn-lg-500": { fontSize: "1.6rem", lineHeight: "1.4", fontWeight: "500" },
    "btn-md-500": { fontSize: "1.4rem", lineHeight: "1.4", fontWeight: "500" },
    "btn-sm-500": { fontSize: "1.2rem", lineHeight: "1.2", fontWeight: "500" },

    "caption-1": { fontSize: "1.2rem", lineHeight: "1.4", fontWeight: "400" },
};
